export const removeKeys = (
  object: Record<string, unknown>,
  arr: string[]
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(object).filter(([key, _]) => !arr.includes(key))
  );
